import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { TravelAbroadExemptionForm } from "../forms/auth-travel-abroad-exemption-form.component";
import { TravelExemptionMfaForm } from "../forms/auth-travel-exemption-mfa-form.component";
import CardControlsComplete from "../misc/card-controls-complete.component";
import { callSubmitTravelExemption } from "../../../actions/mfa.actions";
import { callGetCardOwners } from "../../../actions/cardControls.actions";
import ExistingTravelSelection from "./existing-travel-selection.component";

const TravelAbroadExemptionFlowComponent = (props) => {
  const { setProcessStep, processStep, cardInfo, backToCards } = props;
  const currentForm = props.form["TravelAbroadExemption"];

  const countryOptions = props.cardControls.countryOptions;
  const mfaIsRequired = props.mfa.required === true;  
  
  const [selectedTravel, setSelectedTravel] = useState(null);
  const [travelReason, setTravelReason] = useState("");

  useEffect(() => {
    // If MFA is not required as determined by the eligibility response, skip the MFA form
    if (!mfaIsRequired) {
      setProcessStep(2);
    }
  }, []);

  const editTravel = (travel) => {
    setSelectedTravel(travel);
    setProcessStep(3);
  }

  const showTravelReasonSelectionModal = () => {
    //processStep of 1 - should be in the "add" flow. If we're here, we need
    //to make sure to only show the modal iff the user has no exemptions on this card
    if (processStep === 1) {
      if (props.cardControls.existingTravels.length > 0) {
        return;
      }
    }
    
    props.showCardControlsModal(
      true,
      props.popupMenuOptions.other.EligibleTravelExemption,
      props.cardInfo.agreeNbr,
      props.cardInfo.type,
      props.IsActive,
      props.CardNumberLastFour,
      props.callCancelExistingTravel,
      null, //since we will not be using this modal for existing travels, the existing travel here is not needed
      props.advanceToCompleteStep,
      travelReasonSelected,
      false //since we cannot proceed without a reason, do not show the close button "X" on this modal
    );
  }

  const travelReasonSelected = (method) => {
    setTravelReason(method);
    setProcessStep(3);
  }

  switch (processStep) {
    case 1:
      if (!mfaIsRequired) {
        return null;
      }
      return (
        <TravelExemptionMfaForm
          backToLoans={backToCards}
          advanceToNextStep={() => setProcessStep(2)}
          showTravelReasonSelectionModal={showTravelReasonSelectionModal}
        />
      );
    case 2:
      return (
        <ExistingTravelSelection
          cardInfo={cardInfo}
          existingTravels={props.cardControls.existingTravels}
          existingTravelsLoaded={props.cardControls.existingTravelsLoaded}
          backToCards={backToCards}
          advanceToNextStep={() => setProcessStep(3)}
          editTravel={editTravel}
          showCardControlsModal={props.showCardControlsModal}
          advanceToCompleteStep={() => setProcessStep(4)}
          showTravelReasonSelectionModal={showTravelReasonSelectionModal}
        />
      );
    case 3:
      return (
        <TravelAbroadExemptionForm
          callGetCardOwners={props.callGetCardOwners}
          owners={props.cardControls.cardOwners}
          countryOptions={countryOptions}
          callSubmitTravelExemption={props.callSubmitTravelExemption}
          thisForm={currentForm}
          cardInfo={cardInfo}
          backToCards={backToCards}
          advanceToNextStep={() => setProcessStep(4)}
          selectedTravel={selectedTravel}
          showTravelReasonSelectionModal={showTravelReasonSelectionModal}
          travelReason={travelReason}
        />
      );
    case 4:
      return (
        <CardControlsComplete
          {...props}
          travelExemptionResponse={props.cardControls.travelExemptionResponse}
        />
      );
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callSubmitTravelExemption,
  callGetCardOwners,
};

const TravelAbroadExemptionFlow = connect(
  null,
  mapDispatchToProps
)(TravelAbroadExemptionFlowComponent);

export default TravelAbroadExemptionFlow;



// WEBPACK FOOTER //
// ./src/components/card-controls/flow-components/travel-abroad-exemption-flow.component.js